import { Grid } from "@material-ui/core";
import styled from "styled-components";

const StyledComponent = styled(Grid)`
  outline: none;
  .text {
    display: flex;
    text-align: center;
    align-items: center;
    font-size: 2em;
    margin-bottom: 10px;
    font-family: Calibre-Regular;
    color: ${(props) => props.theme.colors.base.grey};
  }
`;

const StyledWrapper = styled(Grid)`
  background: ${(props) => props.theme.colors.base.white};
  width: 350px;
  text-align: center;
  padding: 1.5em;
  border-radius: 20px;
  border: 3px solid #E14843;

  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    width: 350px;
  }
  ${(props) => props.theme.breakpoints.between("sm", "md")} {
    width: 400px;
  }
  ${(props) => props.theme.breakpoints.between("md", "xl")} {
    width: 500px;
  }
`;

const StyledTextWrapper = styled.div`
  display: block;
  text-align: center;
  align-items: center;  
  font-family: Calibre-Regular;
  color: ${(props) => props.theme.colors.base.grey};
`;

const StyledAuctionEndedWrapper = styled(Grid)`
  text-align: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    padding: 10px 10px;
  }
  ${(props) => props.theme.breakpoints.between("sm", "md")} {
    padding: 10px 20px;
  }
  ${(props) => props.theme.breakpoints.between("md", "xl")} {
    padding: 10px 20px;
  }
`;

const StyledButton = styled.button`
  font-size: 1em;
  text-align: center;
  font-family: Calibre-SemiBold;
  width: 100px;
  padding: 0.5em 0.5em;
  padding-top: 0.8em;
  margin-top: 20px;
  border-radius: 10px;
  margin-left: 10px;
  color: ${(props) => props.theme.colors.base.white};
  border: none;
  border-radius: 5px;
  background: #e14843;
  border: 1px solid ${(props) => props.theme.colors.base.white};
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.base.textColor};
    cursor: pointer;
  }
`;

const StyledDescription = styled.span`
  font-weight: 600;
  display: contents;
`;

const StyledAlertMsg = styled.span`
  font-size: 0.7em;
  color: red;
  font-family: Calibre-SemiBold;
`;

const StyledLabelConversion = styled.label`
  color: ${(props) => props.theme.colors.base.buttonGradientFirstColor};
  font-size: 1em;
  display: inline-block;
`;

const StyledAmountField = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export {
  StyledButton,
  StyledAuctionEndedWrapper,
  StyledTextWrapper,
  StyledWrapper,
  StyledComponent,
  StyledDescription,
  StyledAlertMsg,
  StyledLabelConversion,
  StyledAmountField,
};
